import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Alert,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Dimensions,
  ActivityIndicator,
  Modal,
  ImageBackground
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Ionicons } from '@expo/vector-icons';
import * as ImagePicker from 'expo-image-picker';
import * as FileSystem from 'expo-file-system';
import { API_BASE_URL, API_CONFIG } from '../config/api';
import Constants from "expo-constants";
// Note: Registration endpoint not documented in current API specification
import { fetchUserProfile } from '../services/userDataService';
import { useFocusEffect } from '@react-navigation/native';

import DropDownPicker from 'react-native-dropdown-picker';
import DateTimePicker, { DateType, useDefaultStyles } from 'react-native-ui-datepicker';
import { MaskedTextInput } from "react-native-mask-text";
import { useFonts } from 'expo-font';
import * as DatePickerStyle from '../styles/datepicker.js';
import * as DropdownStyle from '../styles/dropdown.js';

const { width, height } = Dimensions.get('window');

export default function IdentityUploadScreen({ navigation }) {
  const dmyPattern = /^\d{2}-\d{2}-\d{4}$/;
  const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;

  const [formData, setFormData] = useState({
    fullName: '',
    birthDate: '',
    placeOfBirth: '',
    nik: '',
    identityFile: null,
    province: '',
    city: '',
    address: '',
    gender: '',
  });
  const [ocrData, setOcrData] = useState({
    fullName: '',
    birthDate: '',
    placeOfBirth: '',
    nik: '',
    gender: '',
    province: '',
    city: ''
  });

  const [genders, setGenders] = useState([
    {label: 'Laki-Laki', value: 'LAKI-LAKI'},
    {label: 'Perempuan', value: 'PEREMPUAN'},
  ]);
  const [isGenderOpen, setIsGenderOpen] = useState(false);

  const [isLoadProvinces, setIsLoadProvinces] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [isProvinceOpen, setIsProvinceOpen] = useState(false);

  const [isLoadCities, setIsLoadCities] = useState(false);
  const [cities, setCities] = useState([]);
  const [isCityOpen, setIsCityOpen] = useState(false);
  const [ocrCity, setOcrCity] = useState('');

  const [openDropdown, setOpenDropdown] = useState('');

  const [currentProvince, setCurrentProvince] = useState('');

  const [isLoadUserData, setIsLoadUserData] = useState(false);
  const [userData, setUserData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [isProcessingOCR, setIsProcessingOCR] = useState(false);
  const [isFieldEditable, setIsFieldEditable] = useState(false);

  // Custom Alert Modal State
  const [alertModal, setAlertModal] = useState({
    visible: false,
    title: '',
    message: '',
    type: 'error' // 'error' or 'success'
  });

  const datepickerDefaultStyles = useDefaultStyles();
  const [datepickerDate, setDatepickerDate] = useState(new Date());
  const [isDatepickerShown, setIsDatepickerShown] = useState(false);

  const hideDatePicker = () => {
    setIsDatepickerShown(false);
  }

  const handleShowDatepicker = (date = null) => {
    if (date instanceof Date) {
      setDatepickerDate( date );
    } else if (typeof date === 'string') {
      let selectedDate = new Date();

      if( ymdPattern.test(date) ) selectedDate = new Date(date);
      else if(dmyPattern.test(date)) {
        const parts = date.split('-');
        selectedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      }

      // handle user giving invalid number string
      if(isNaN(selectedDate.getTime())) {
        if( date == formData.birthDate ) {
          handleInputChange('birthDate', '');
        }
        selectedDate = new Date();
      }

      setDatepickerDate(selectedDate);
    } else {
      setDatepickerDate( new Date() );
    }

    setIsDatepickerShown(true);
  }

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Custom Alert Functions
  const showCustomAlert = (title, message, type = 'error') => {
    setAlertModal({
      visible: true,
      title,
      message,
      type
    });
  };

  const hideCustomAlert = () => {
    setAlertModal(prev => ({ ...prev, visible: false }));
  };

  const loadUserData = async () => {
    try {
      setIsLoadUserData(true);
      const result = await fetchUserProfile();
      
      if (result.data) {
        setUserData(result.data);
        const tmpFormData = {
          fullName: result.data?.user_fullname ?? '',
          birthDate: result.data.user_dob ?? '',
          placeOfBirth: result.data.user_identity_pob ?? '',
          nik: result.data.user_identity_number ?? '',
          identityFile: result.data.user_identity_file ?? '',
          province: result.data.user_address_province ?? '',
          city: result.data.user_address_city ?? '',
          address: result.data.user_address_detail ?? '',
          gender: result.data.user_gender ?? '',
        }

        setFormData(prev => ({
          ...prev,
          ...tmpFormData
        }));
      } else {
        throw new Error(result.message ?? 'Gagal memuat data identitas');
      }
    } catch (error) {
      console.error('Error loading user identity:', error);
      showCustomAlert('Error', 'Gagal memuat data identitas. Silakan coba lagi.');
    } finally {
      setIsLoadUserData(false);
      setIsFieldEditable(false);
    }
  };

  const processOCRKTP = async (base64KTP) => {
    try {
      setIsProcessingOCR(true);
      console.log('Processing KTP image with OCR...');

      // Call the documented /api/v1/createsso endpoint
      const response = await fetch(`${API_BASE_URL}/api/v1/ocr-identity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY ||
            "9f3c7a2d1b84e6f5c0a9d27e4b6f8a1c5d3e9b7a0c2f4e6d8a1b3c5f7e9d2",
        },
        body: JSON.stringify({
          "identity-number": "",
          "identity-file": base64KTP,
        }),
      });

      const result = await response.json();

      if (result.status !== "success") {
        setIsFieldEditable(false);
        setUploadedFileName('');
        showCustomAlert(
          'Informasi',
          'Data KTP tidak dapat dibaca dengan jelas atau tidak sesuai format yang valid.\n\nSilakan:\n1. Pastikan foto KTP jelas dan tidak buram\n2. Pastikan pencahayaan cukup\n3. Isi form secara manual jika diperlukan'
        );
      } else {

        // console.log('OCR Result:', result.data);

        // Validation rules before filling form
        let validDataCount = 0;
        let filledFields = [];
        let validatedData = {};

        const ocrIdentityData = result.data;
        validatedData.nik = ocrIdentityData.number;
        validDataCount++;
        filledFields.push('NIK');

        validatedData.fullName = ocrIdentityData.name;
        validDataCount++;
        filledFields.push('Nama');

        validatedData.placeOfBirth = ocrIdentityData.place;
        validDataCount++;
        filledFields.push('Tempat Lahir');

        if( dmyPattern.test(ocrIdentityData.dob) ) {
          const dateParts = ocrIdentityData.dob.split('-');
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);
          const date = new Date(year, month - 1, day);
          const currentDate = new Date();
          const age = currentDate.getFullYear() - year;

          if (
            date.getFullYear() === year 
            && date.getMonth() === month - 1 
            && date.getDate() === day 
            && age > 0 
            && age < 120
          ) {
            validatedData.birthDate = ocrIdentityData.dob;
            validDataCount++;
            filledFields.push('Tanggal Lahir');
          }
        }

        validatedData.province = '';
        if( provinces.map(p => p.value).includes(ocrIdentityData.province?.toUpperCase()) ) {
          validatedData.province = ocrIdentityData.province?.toUpperCase();
          validDataCount++;
          filledFields.push('Provinsi');
        }

        validatedData.city = '';
        setOcrCity(ocrIdentityData.city?.toUpperCase());
        validDataCount++;
        filledFields.push('Kab/Kota');

        validatedData.address = ocrIdentityData.address;
        validDataCount++;
        filledFields.push('Alamat Detail');

        validatedData.gender = ocrIdentityData.gender?.toUpperCase();
        validDataCount++;
        filledFields.push('Jenis Kelamin');

        setOcrData(prev => ({
          ...prev,
          ...validatedData
        }));

        // Pre-fill form with validated data
        if (validDataCount > 0) {
          setFormData(prev => ({
            ...prev,
            ...validatedData
          }));

          setIsFieldEditable(true);

          showCustomAlert(
            'KTP Berhasil Dipindai',
            `Data KTP berhasil dipindai!\n\nField yang terisi: ${filledFields.join(', ')}\n\nSilakan periksa dan lengkapi data yang masih kosong.`,
            'success'
          );
        } else {
          setIsFieldEditable(false);
          setUploadedFileName('');
          showCustomAlert(
            'Informasi',
            'Data KTP tidak dapat dibaca dengan jelas atau tidak sesuai format yang valid.\n\nSilakan:\n1. Pastikan foto KTP jelas dan tidak buram\n2. Pastikan pencahayaan cukup\n3. Isi form secara manual jika diperlukan'
          );
        }
      }
    } catch (error) {
      console.error('OCR Error:', error);
      setUploadedFileName('');
      showCustomAlert(
        'Gagal Memindai KTP',
        'Tidak dapat membaca data dari KTP. Silakan isi form secara manual.'
      );
    } finally {
      setIsProcessingOCR(false);
    }
  };

  const handleImagePicker = async () => {
    try {
      // Request permission
      const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (permissionResult.granted === false) {
        showCustomAlert('Error', 'Izin akses galeri diperlukan untuk upload KTP');
        return;
      }

      // Launch image picker
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [4, 3],
        quality: 0.8,
        base64: true,
      });

      if (!result.canceled && result.assets[0]) {
        const asset = result.assets[0];
        // console.log('Selected image MIME type:', asset.uri);
        // const mimeType = asset.mimeType || (asset.uri.endsWith('.webp') ? 'image/webp' : 'image/jpeg');
        // console.log('Selected image MIME type:', mimeType);
        // const base64Image = `data:${mimeType};base64,${asset.base64}`;

        const base64Image = asset.uri;
        // const base64Image = `data:${asset.type || 'image/jpeg'};base64,${asset.base64}`;

        setFormData(prev => ({
          ...prev,
          identityFile: base64Image
        }));

        // Set filename for display
        const fileName = asset.fileName || `ktp_${Date.now()}.jpg`;
        setUploadedFileName(fileName);

        // Process KTP image with OCR
        // await processKTPImage(asset.uri);

        if (asset.size / 1024 / 1024 > 10) {
          setUploadedFileName('');
          showCustomAlert('Error', 'Ukuran file lebih dari batas maksimal 10MB');
          return;
        }

        await processOCRKTP(base64Image);

      }
    } catch (error) {
      console.error('Error picking image:', error);
      showCustomAlert('Error', 'Gagal memilih gambar. Silakan coba lagi.');
    }
  };

  const validateForm = () => {
    const { fullName, nik, birthDate, placeOfBirth, identityFile, province, city, address, gender } = formData;

    console.log('=== FORM VALIDATION START ===');
    // console.log('Form data:', formData);
    // console.log('acceptTerms:', acceptTerms);
    // console.log('ageConfirmation:', ageConfirmation);

    if (!identityFile) {
      console.log('VALIDATION FAILED: No identity file uploaded');
      showCustomAlert('Error', 'Upload KTP diperlukan');
      return false;
    }

    if (!fullName.trim()) {
      console.log('VALIDATION FAILED: No full name provided');
      showCustomAlert('Error', 'Nama lengkap harus diisi');
      return false;
    }

    if (!nik.trim()) {
      console.log('VALIDATION FAILED: No NIK provided');
      showCustomAlert('Error', 'NIK harus diisi');
      return false;
    }

    if (!/^\d{16}$/.test(nik)) {
      console.log('VALIDATION FAILED: Invalid NIK format:', nik, 'Length:', nik.length);
      showCustomAlert('Error', 'NIK harus 16 digit');
      return false;
    }

    if ( !birthDate.trim()) {
      console.log('VALIDATION FAILED: No birth date provided');
      showCustomAlert('Error', 'Tanggal lahir harus diisi');
      return false;
    }

    // Validate date format (DD-MM-YYYY)
    if (!dmyPattern.test(birthDate)) {
      console.log('VALIDATION FAILED: Invalid birth date format:', birthDate);
      showCustomAlert('Error', 'Format tanggal lahir harus DD-MM-YYYY (contoh: 15-01-1990)');
      return false;
    }

    // Validate that the date is a valid date
    const dateParts = birthDate.split('-');
    const day = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]);
    const year = parseInt(dateParts[2]);
    const date = new Date(year, month - 1, day);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      console.log('VALIDATION FAILED: Invalid birth date object:', birthDate);
      showCustomAlert('Error', 'Tanggal lahir tidak valid');
      return false;
    }

    // Validate reasonable birth date range
    const currentDate = new Date();
    const age = currentDate.getFullYear() - year;
    if (age < 0 || age > 120) {
      console.log('VALIDATION FAILED: Invalid age:', age);
      showCustomAlert('Error', 'Tanggal lahir tidak masuk akal');
      return false;
    }

    if (!placeOfBirth.trim()) {
      console.log('VALIDATION FAILED: No place of birth provided');
      showCustomAlert('Error', 'Tempat lahir harus diisi');
      return false;
    }

    if (!gender.trim()) {
      console.log('VALIDATION FAILED: No gender provided');
      showCustomAlert('Error', 'Jenis kelamin harus dipilih');
      return false;
    }

    console.log(gender.trim().toUpperCase());
    if (!['LAKI-LAKI', 'PEREMPUAN'].includes(gender.trim().toUpperCase())) {
      console.log('VALIDATION FAILED: Invalid gender provided');
      showCustomAlert('Error', 'Jenis kelamin tidak valid');
      return false;
    }

    if (!province.trim()) {
      console.log('VALIDATION FAILED: No province provided');
      showCustomAlert('Error', 'Provinsi harus dipilih');
      return false;
    }

    if (!provinces.map(p => p.value).includes(province)) {
      console.log('VALIDATION FAILED: Invalid province provided');
      showCustomAlert('Error', 'Provinsi harus dipilih');
      return false;
    }

    if (!city.trim()) {
      console.log('VALIDATION FAILED: No city provided');
      showCustomAlert('Error', 'Kab/Kota harus dipilih');
      return false;
    }

    if (!cities.map(c => c.value).includes(city)) {
      console.log('VALIDATION FAILED: Invalid city provided');
      showCustomAlert('Error', 'Kab/Kota harus dipilih');
      return false;
    }

    // if (!address.trim()) {
    //   console.log('VALIDATION FAILED: No address provided');
    //   showCustomAlert('Error', 'Alamat detail harus diisi');
    //   return false;
    // }

    console.log('=== FORM VALIDATION PASSED ===');
    return true;
  };

  const handleVerify = async () => {
    console.log('handleVerify called');
    console.log('isLoading:', isLoading);

    if (!validateForm()) {
      console.log('Form validation failed');
      return;
    }

    if (!userData) {
      console.log('Form validation failed');
      return;
    }

    console.log('Form validation passed, starting verification...');
    setIsLoading(true);

    try {
      // Prepare verification data according to updated API specification
      const verificationData = new FormData(); 
      verificationData.append('user_id', userData.user_email);
      verificationData.append('identity-file', formData.identityFile);
      verificationData.append('identity-number', formData.nik);

      verificationData.append('ocr-fullname', ocrData.fullName?.toUpperCase() || formData.fullName.toUpperCase());
      verificationData.append('ocr-date-of-birth', formatDateForIdentity(ocrData.birthDate) || formatDateForIdentity(formData.birthDate));// DD-MM-YYYY format
      verificationData.append('ocr-nik', ocrData.nik || formData.nik);
      verificationData.append('ocr-place-dob', ocrData.placeOfBirth?.toUpperCase() || formData.placeOfBirth.toUpperCase());
      verificationData.append('ocr-gender', ocrData.gender?.toUpperCase() || formData.gender.toUpperCase());
      verificationData.append('ocr-province', ocrData.province?.toUpperCase() || formData.province.toUpperCase());
      verificationData.append('ocr-city', ocrData.city?.toUpperCase() || formData.city.toUpperCase());

      console.log('Sending verification request...');

      const response = await fetch(`${API_BASE_URL}/api/v1/verify-identity`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY
        },
        body: verificationData
      });

      const result = await response.json();

      if (result.status === 'success') {
        // Store user data if verification successful
        if (result.data && result.data.userData) {
          await AsyncStorage.setItem('userData', JSON.stringify(result.data.userData));

          // Store session data if provided
          if (result.data.userData.remember_token) {
            await AsyncStorage.setItem('remember_token', result.data.userData.remember_token);
          }
        }

        showCustomAlert(
          'Berhasil',
          result.message || 'Verifikasi identitas berhasil!',
          'success'
        );

        // Navigate to login after a short delay
        setTimeout(() => {
          navigation.replace('IdentityUpload');
        }, 2000);
      } else {
        if( typeof result.message === "string" ) {
          showCustomAlert('Error', result.message || 'Verifikasi identitas gagal. Silakan coba lagi.');
        } else if( typeof result.message === "object" ) {
          const messages = Object.values(result.message).join(". ").replace(/<[^>]*>/g, '');
          showCustomAlert('Error', messages || 'Verifikasi identitas gagal. Silakan coba lagi.');
        }
      }

    } catch (error) {
      console.error('Verification error:', error);
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        showCustomAlert('Error', 'Koneksi internet bermasalah. Silakan periksa koneksi Anda.');
      } else {
        showCustomAlert('Error', error.message || 'Verifikasi identitas gagal. Silakan coba lagi.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to format date from DD-MM-YYYY or YYYY-MM-DD to DD-MM-YYYY
  const formatDateForIdentity = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    if (parts.length === 3) {
      // Check if it's already in DD-MM-YYYY format (day <= 31, month <= 12)
      if (parseInt(parts[0]) <= 31 && parseInt(parts[1]) <= 12) {
        return dateString; // Already in DD-MM-YYYY format
      }
      // Convert from YYYY-MM-DD to DD-MM-YYYY
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  };

  const loadProvinces = async () => {
    setIsLoadProvinces(true);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/provinces`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
      });

      const result = await response.json();
      setProvinces( result.data.map(province => {
        return {
          label: province.nama_provinsi?.toUpperCase(),
          value: province.nama_provinsi?.toUpperCase(),
        };
      }) );

    } catch(e) {
      console.log(e);
      setProvinces([])
    } finally {
      setIsLoadProvinces(false);
    }
  }

  const loadCities = async () => {
    setIsLoadCities(true);

    const provinceData = new FormData();
    provinceData.append('provinsi', formData.province);

    try{
      const response = await fetch(`${API_BASE_URL}/api/v1/cities`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Api-Key": Constants.expoConfig?.extra?.API_KEY,
        },
        body: provinceData
      });

      const result = await response.json();
      setCities( result.data.map(city => {
        return {
          label: city.nama_kota?.toUpperCase(),
          value: city.nama_kota?.toUpperCase(),
        };
      }) );

    } catch(e) {
      console.log(e);
      setCities([])
    } finally {
      setIsLoadCities(false);
    }
  }

  useFocusEffect(
    React.useCallback(() => {
      loadUserData();
    }, [navigation])
  );

  useEffect(() => {
    if(userData && !userData.user_identity_file) {
      loadProvinces();
    }
  }, [userData]);

  useEffect(() => {
    if( isProvinceOpen ) setOpenDropdown('province');
    if( isCityOpen ) setOpenDropdown('city');
  }, [isProvinceOpen, isCityOpen]);

  // close datepicker when back button clicked
  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      if( !isDatepickerShown ) {
        return;
      }

      e.preventDefault();
      hideDatePicker();
    });

    return unsubscribe;
  }, [navigation, isDatepickerShown]);

  // useEffect(() => {
  //   // first time got province from OCR
  //   if(formData.province && document.getElementById('province').value != formData.province) {
  //     loadCities();
  //   }

  //   if( formData.birthDate ){
  //     document.getElementById('birthDate').value = formData.birthDate;
  //   }
  //   document.getElementById('province').value = formData.province;
  //   document.getElementById('city').value = formData.city;
  // }, [formData]);

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <View style={styles.container}>
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.header}>
            <TouchableOpacity
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <Ionicons name="arrow-back" size={24} color="#000000" />
            </TouchableOpacity>
          </View>

          {isLoadUserData || isLoadProvinces ? (
            <ActivityIndicator size="large" color="#1E293B" />
          ) : (
            <View style={styles.content}>
              <View style={styles.titleSection}>
                <Text style={styles.title}>{userData?.user_identity_file ? `Terverifikasi` : `Verifikasi Identitas`}</Text>
                <Text style={styles.subtitle}>
                  {userData?.user_identity_file ? `Kamu sudah bisa bertransaksi di zoolyfe.id` : `Diperlukan untuk bertransaksi di zoolyfe.id`}
                </Text>
              </View>

              <View style={styles.formSection}>
                {userData?.user_identity_file ? (
                  <View style={styles.identityCard}>
                    <ImageBackground
                      source={`${API_CONFIG.BASE_URL}/${userData.user_identity_file}`}
                      style={styles.identityCardBackground}
                      imageStyle={styles.identityCardImage}
                      resizeMode="contain"
                      onLoad={() => console.log('Image loaded successfully')}
                      onError={(error) => console.log('Image load error:', error)}
                    ></ImageBackground>
                  </View>
                ) : (
                  <View style={styles.formGroup}>
                    <Text style={styles.label}>Upload KTP *</Text>
                    <TouchableOpacity
                      style={[styles.uploadContainer, isProcessingOCR && styles.uploadContainerProcessing]}
                      onPress={handleImagePicker}
                      disabled={isProcessingOCR}
                    >
                      <View style={styles.uploadContent}>
                        {isProcessingOCR ? (
                          <>
                          <ActivityIndicator size="large" color="#3B82F6" />
                          <Text style={styles.uploadText}>Memindai KTP...</Text>
                          <Text style={styles.uploadSubtext}>Mohon tunggu, sedang menganalisis gambar KTP</Text>
                          </>
                        ) : (
                          <>
                          <Ionicons name="document-outline" size={24} color="#94A3B8" />
                          <Text style={styles.uploadText}>
                              {uploadedFileName || 'Upload KTP'}
                          </Text>
                          <Text style={styles.uploadSubtext}>Klik atau Tarik file ke kotak ini. Format: JPEG/PNG</Text>
                          {uploadedFileName && (
                              <Text style={styles.ocrHintText}>✨ Data akan diisi otomatis setelah upload</Text>
                          )}
                          </>
                        )}
                      </View>
                    </TouchableOpacity>
                  </View>
                )}

                <View style={styles.formGroup}>
                  <Text style={styles.label}>{`Nama Sesuai KTP *`}</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <TextInput
                      style={styles.input}
                      placeholder={`Nama Sesuai KTP `}
                      placeholderTextColor="#94A3B8"
                      value={formData.fullName}
                      onChangeText={(value) => handleInputChange('fullName', value)}
                      autoCapitalize="words"
                      autoCorrect={false}
                      editable={isFieldEditable}
                    />
                  </View>
                </View>

                {userData?.user_identity_file ? (
                  <View style={styles.formGroup}>
                    <Text style={styles.label}>{`Jenis Kelamin *`}</Text>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <TextInput
                        style={styles.input}
                        placeholder={`Jenis Kelamin`}
                        placeholderTextColor="#94A3B8"
                        value={formData.gender}
                        autoCapitalize="words"
                        autoCorrect={false}
                        editable={isFieldEditable}
                      />
                    </View>
                  </View>
                ) : (
                  <View 
                    style={{
                      ...styles.formGroup,
                      zIndex: 5000,
                    }}
                  >
                    <Text style={styles.label}>Jenis Kelamin *</Text>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <DropDownPicker
                        style={DropdownStyle.customStyles.dropdown}
                        textStyle={DropdownStyle.customStyles.dropdownText}
                        disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                        placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                        dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                        listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                        labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                        placeholder="Jenis Kelamin"
                        searchable={false}
                        open={isGenderOpen}
                        value={formData.gender}
                        items={genders}
                        setOpen={setIsGenderOpen}
                        setItems={setGenders}
                        onSelectItem={(item) => {
                          handleInputChange('gender', item.value);
                        }}
                        disabled={!isFieldEditable}
                      />
                    </View>
                  </View>
                )}
                
                <View style={styles.formGroup}>
                  <Text style={styles.label}>Tanggal Lahir *</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <MaskedTextInput
                      mask="99-99-9999"
                      style={styles.input}
                      placeholder="DD-MM-YYYY"
                      placeholderTextColor="#94A3B8"
                      value={formData.birthDate}
                      onChangeText={(text, rawText) => {
                        // const dobPattern = /^\d{2}-\d{2}-\d{4}$/;
                        // if( dobPattern.test(text) ) {
                          handleInputChange('birthDate', text);
                        // }
                      }}
                      keyboardType="numeric"
                      editable={isFieldEditable}
                    />
                    <TouchableOpacity
                      style={styles.inputIcon}
                      onPress={() => handleShowDatepicker(formData.birthDate)}
                      disabled={!isFieldEditable}
                    >
                      <Ionicons
                        name="calendar-outline"
                        size={20}
                        color="#64748B"
                      />
                    </TouchableOpacity>
                  </View>
                </View>
                
                <View style={styles.formGroup}>
                  <Text style={styles.label}>Tempat Lahir *</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <TextInput
                      style={styles.input}
                      placeholder="Tempat lahir"
                      placeholderTextColor="#94A3B8"
                      value={formData.placeOfBirth}
                      onChangeText={(value) => handleInputChange('placeOfBirth', value)}
                      autoCapitalize="words"
                      autoCorrect={false}
                      editable={isFieldEditable}
                    />
                  </View>
                </View>
                
                <View style={styles.formGroup}>
                  <Text style={styles.label}>NIK *</Text>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <TextInput
                      style={styles.input}
                      placeholder='NIK'
                      placeholderTextColor="#94A3B8"
                      value={formData.nik}
                      onChangeText={(value) => handleInputChange('nik', value)}
                      keyboardType="numeric"
                      autoCorrect={false}
                      editable={isFieldEditable}
                    />
                  </View>
                </View>

                {userData?.user_identity_file ? (
                  <View style={styles.formGroup}>
                    <Text style={styles.label}>{`Alamat *`}</Text>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <TextInput
                        style={styles.input}
                        placeholder={`Provinsi`}
                        placeholderTextColor="#94A3B8"
                        value={formData.province}
                        autoCapitalize="words"
                        autoCorrect={false}
                        editable={isFieldEditable}
                      />
                    </View>
                  </View>
                ) : (
                  <View 
                    style={{
                      ...styles.formGroup,
                      zIndex: openDropdown == 'province' ? 5001 : 5000,
                    }}
                  >
                    <Text style={styles.label}>Alamat *</Text>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <DropDownPicker
                        style={DropdownStyle.customStyles.dropdown}
                        textStyle={DropdownStyle.customStyles.dropdownText}
                        disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                        placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                        dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                        listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                        labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                        searchContainerStyle={DropdownStyle.customStyles.dropdownSearch}
                        searchTextInputStyle={DropdownStyle.customStyles.dropdownSearchText}
                        searchTextInputProps={{
                          autoFocus: true,
                        }}
                        placeholder="Provinsi"
                        searchable={true}
                        open={isProvinceOpen}
                        value={formData.province}
                        items={provinces}
                        setOpen={setIsProvinceOpen}
                        setItems={setProvinces}
                        onSelectItem={(item) => {
                          handleInputChange('province', item.value);
                        }}
                        onChangeValue={async ()=>{
                          await loadCities();
                          handleInputChange('city', ocrCity);
                          if( !formData.city ) {
                            setOcrCity('');
                          }
                        }}
                        disabled={!isFieldEditable}
                      />
                    </View>
                  </View>
                )}

                {userData?.user_identity_file ? (
                  <View style={styles.formGroup}>
                    <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                      <TextInput
                        style={styles.input}
                        placeholder={`City`}
                        placeholderTextColor="#94A3B8"
                        value={formData.city}
                        autoCapitalize="words"
                        autoCorrect={false}
                        editable={isFieldEditable}
                      />
                    </View>
                  </View>
                ) : (
                  <View 
                    style={{
                      ...styles.formGroup,
                      zIndex: openDropdown == 'city' ? 5001 : 5000,
                    }}
                  >
                    <View style={isLoadCities || !isFieldEditable || !formData.province ? styles.inputContainerDisabled : styles.inputContainer}>
                      <DropDownPicker
                        style={DropdownStyle.customStyles.dropdown}
                        textStyle={DropdownStyle.customStyles.dropdownText}
                        disabledStyle={DropdownStyle.customStyles.dropdownDisabled}
                        placeholderStyle={DropdownStyle.customStyles.dropdownPlaceholder}
                        dropDownContainerStyle={DropdownStyle.customStyles.dropdownContainer}
                        listItemLabelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                        labelStyle={DropdownStyle.customStyles.dropdownItemLabel}
                        searchContainerStyle={DropdownStyle.customStyles.dropdownSearch}
                        searchTextInputStyle={DropdownStyle.customStyles.dropdownSearchText}
                        searchTextInputProps={{
                          autoFocus: true,
                        }}
                        placeholder="Kab/Kota"
                        searchable={true}
                        open={isCityOpen}
                        value={formData.city}
                        items={cities}
                        setOpen={setIsCityOpen}
                        setItems={setCities}
                        onSelectItem={(item) => {
                          handleInputChange('city', item.value);
                        }}
                        disabled={isLoadCities || !isFieldEditable || !formData.province}
                      />
                    </View>
                  </View>
                )}
                
                {/*<View style={styles.formGroup}>
                  <View style={isFieldEditable ? styles.inputContainer : styles.inputContainerDisabled}>
                    <TextInput
                      style={styles.input}
                      placeholder='Alamat Detail'
                      value={formData.address}
                      onChangeText={(value) => handleInputChange('address', value)}
                      placeholderTextColor="#94A3B8"
                      keyboardType="numeric"
                      autoCorrect={false}
                      editable={isFieldEditable}
                    />
                  </View>
                </View>*/}

                {!userData?.user_identity_file && (
                  <TouchableOpacity
                    style={[styles.registerButton, (isLoading) && styles.disabledButton]}
                    onPress={handleVerify}
                    disabled={isLoading}
                  >
                    <Text style={styles.registerButtonText}>
                      {isLoading ? 'Memverifikasi...' : 'Verifikasi'}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>
            </View>
          )}
        </ScrollView>
      </View>

      {/* Custom Alert Modal */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={alertModal.visible}
        onRequestClose={hideCustomAlert}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <View style={[styles.modalHeader, alertModal.type === 'success' ? styles.successHeader : styles.errorHeader]}>
              <Text style={styles.modalTitle}>{alertModal.title}</Text>
            </View>
            <View style={styles.modalBody}>
              <Text style={styles.modalMessage}>{alertModal.message}</Text>
            </View>
            <View style={styles.modalFooter}>
              <TouchableOpacity
                style={[styles.modalButton, alertModal.type === 'success' ? styles.successButton : styles.errorButton]}
                onPress={hideCustomAlert}
              >
                <Text style={styles.modalButtonText}>OK</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Date Picker Modal */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={isDatepickerShown}
        onRequestClose={hideDatePicker}
      >
        <TouchableOpacity 
          style={DatePickerStyle.modalStyles.datepickerOverlay}
          onPress={hideDatePicker}
          activeOpacity={1}
        >
          <TouchableOpacity 
            style={DatePickerStyle.modalStyles.datepickerContainer} 
            onPress={(e) => e.stopPropagation()}
            activeOpacity={1}
          >
            <View style={DatePickerStyle.modalStyles.datepickerBody}>
              <DateTimePicker
                locale="id"
                mode="single"
                maxDate={new Date()}
                date={datepickerDate}
                onChange={({ date }) => {
                  setDatepickerDate(date);
                  
                  const dateString = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
                  handleInputChange('birthDate', dateString);
                  hideDatePicker();
                }}
                styles={{
                  ...datepickerDefaultStyles,
                  ...DatePickerStyle.customStyles
                }}
              />
            </View>
            <View style={DatePickerStyle.modalStyles.datepickerFooter}>
              <TouchableOpacity
                onPress={hideDatePicker}
              >
                <Text style={DatePickerStyle.modalStyles.datepickerCancelButton}>Batal</Text>
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </TouchableOpacity>
      </Modal>
    </KeyboardAvoidingView>
  );
}


const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  scrollContent: {
    flexGrow: 1,
    padding: 16,
    paddingTop: 32,
  },
  header: {
    marginBottom: 32,
  },
  backButton: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
  },
  titleSection: {
    marginBottom: 32,
  },
  title: {
    fontSize: 30,
    lineHeight: 36,
    fontFamily: 'Poppins-Semibold',
    fontWeight: 600,
    color: '#00000',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: 24,
    fontFamily: 'Poppins',
    color: '#64748B',
  },
  formSection: {
    flex: 1,
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: '#374151',
    marginBottom: 8,
    fontFamily: 'Poppins-Medium',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    paddingHorizontal: 16,
    height: 48,
  },
  inputContainerDisabled: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#E2E8F0',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    paddingHorizontal: 16,
    height: 48,
  },
  input: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
    fontFamily: 'Poppins',
  },
  inputDisabled: {
    flex: 1,
    fontSize: 16,
    color: '#1E293B',
    backgroundColor: '#E2E8F0',
  },
  eyeIcon: {
    padding: 4,
  },
  inputIcon: {
    marginLeft: 8,
  },
  uploadContainer: {
    borderWidth: 1,
    borderColor: '#94A3B8',
    borderStyle: 'dashed',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: 136,
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadContent: {
    alignItems: 'center',
    width: 208,
  },
  uploadText: {
    fontSize: 14,
    color: '#1E293B',
    marginTop: 8,
    fontWeight: '600',
    fontFamily: 'Poppins',
    textAlign: 'center',
  },
  uploadSubtext: {
    fontSize: 12,
    color: '#94A3B8',
    marginTop: 4,
    fontFamily: 'Poppins',
    textAlign: 'center',
    lineHeight: 16,
  },
  uploadContainerProcessing: {
    borderColor: '#3B82F6',
    backgroundColor: '#F0F9FF',
  },
  ocrHintText: {
    fontSize: 11,
    color: '#3B82F6',
    marginTop: 6,
    fontFamily: 'Poppins',
    textAlign: 'center',
    fontWeight: '500',
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 24,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
    marginTop: 2,
  },
  checkboxChecked: {
    backgroundColor: '#000000',
    borderColor: '#000000',
  },
  checkboxText: {
    flex: 1,
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
  },
  linkText: {
    color: '#3B82F6',
    fontWeight: '500',
  },
  registerButton: {
    backgroundColor: '#000000',
    borderRadius: 6,
    padding: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  disabledButton: {
    opacity: 0.7,
  },
  registerButtonText: {
    fontFamily: 'Poppins-Medium',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 20,
    color: '#FFFFFF',
  },
  loginContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginText: {
    fontSize: 14,
    color: '#64748B',
  },
  loginLink: {
    fontSize: 14,
    color: '#3B82F6',
    fontWeight: '600',
  },
  // Custom Modal Styles
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    width: '100%',
    maxWidth: 320,
    overflow: 'hidden',
    elevation: 5,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  modalHeader: {
    padding: 20,
    paddingBottom: 15,
  },
  successHeader: {
    backgroundColor: '#10B981',
  },
  errorHeader: {
    backgroundColor: '#EF4444',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  modalBody: {
    padding: 20,
    paddingTop: 10,
    paddingBottom: 15,
  },
  modalMessage: {
    fontSize: 16,
    color: '#374151',
    textAlign: 'center',
    lineHeight: 24,
  },
  modalFooter: {
    padding: 20,
    paddingTop: 10,
  },
  modalButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
  },
  successButton: {
    backgroundColor: '#10B981',
  },
  errorButton: {
    backgroundColor: '#EF4444',
  },
  modalButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
  identityCard: {
    width: '100%',
    borderRadius: 12,
    minHeight: 200,
    position: 'relative',
    overflow: 'hidden',
    marginBottom: 12,
  },
  identityCardBackground: {
    flex: 1,
    minHeight: 120,
  },
  identityCardImage: {
    borderRadius: 12,
  },
});